
import { updateDiagramStepLabelFontSize, getDiagramStepLabelFontSize } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepLabelFontSizeProps = {
    font_size?: string;
}

export const changeStepLabelFontSize = ({ font_size }: StepLabelFontSizeProps) => {
    updateDiagramStepLabelFontSize({ font_size });
}

export const getStepLabelFontSize = () => getDiagramStepLabelFontSize();
